export default {
  button_bar: {
    docx_button: {
      label: "Download in Word"
    },
    error: "Some fields missing.",
    print_button: {
      label: "Print/save as PDF"
    }
  },
  form: {
    contract_details: {
      headline: "Contract Details",
      agreement_date: {
        label: "Agreement Date",
        placeholder: "Date for entering the Agreement"
      },
      contract_type: {
        label: "Contract Type",
        distributor_label: "Distributor",
        supplier_label: "Supplier"
      }
    },
    distributor_rights_and_obligations: {
      legend: "The Distributor's Rights and Obligations",
      marketing_percent: {
        label: "Marketing Percentage",
        placeholder: "Amount of marketing cut in %"
      },
      number_of_fairs: {
        label: "Amount of yearly fairs",
        placeholder: "Amount of yearly fairs"
      },
      should_participate_in_fairs: {
        label: "Should the Distributor participate in yearly fairs?"
      }
    },
    duration_and_resignation: {
      duration: {
        label: "Duration Type",
        options: {
          limited_auto_renew: "Limited period with automatic renewal",
          unlimited: "Unlimited"
        }
      },
      earliest_resignation: {
        label: "Earliest resignation",
        placeholder: "Date for earliest resignation"
      },
      from_date: {
        label: "From date",
        placeholder: "Agreement start date"
      },
      to_date: {
        label: "To date",
        placeholder: "Agreement end date"
      },
      period: {
        label: "Period",
        placeholder: "Length of the Period"
      },
      legend: "Duration of the Agreement and resignation"
    },
    goodwill: {
      legend: "Compensation for goodwill",
      goodwill_percent: {
        label: "Compensation for goodwill in per cent",
        placeholder: "Percentage rate for goodwill compensation"
      }
    },
    other_regulations: {
      legend: "Other regulations and other additions",
      other_regulations_input: {
        label: "Other regulations",
        placeholder: "Insert regulation",
        add_button_label: "Add regulation"
      }
    },
    parties: {
      distributor: {
        address: {
          label: "Adress",
          placeholder: "Address of the Distributor"
        },
        country: {
          label: "Country",
          placeholder: "Country of the Distributor"
        },
        cvr: {
          label: "CVR-number",
          placeholder: "CVR-number of the Distributor"
        },
        headline: "The Distributor",
        name: {
          label: "Name",
          placeholder: "Name of the Distributor"
        },
        zip_city: {
          label: "Zip and city",
          placeholder: "Zip and city of the Distributor"
        }
      },
      supplier: {
        address: {
          label: "Adress",
          placeholder: "Address of the Supplier"
        },
        country: {
          label: "Country",
          placeholder: "Country of the Supplier"
        },
        cvr: {
          label: "CVR-number",
          placeholder: "CVR-number of the Supplier"
        },
        headline: "The Supplier",
        name: {
          label: "Name",
          placeholder: "Name of the Supplier"
        },
        zip_city: {
          label: "Zip and city",
          placeholder: "Zip and city of the Supplier"
        }
      }
    },
    product_and_area: {
      areas: {
        label: "The Territory",
        placeholder: "The Territory"
      },
      legend: "Product and Territory",
      products: {
        add_button_label: "Add Product",
        label: "The Products",
        placeholder: "The Product"
      },
      exclusive_right: {
        label: "Is the Distributor the exclusive distributor?"
      }
    },
    shared: {
      cvr_error: "Please enter a valid CVR-number (8 digits)",
      remove_button_label: "Remove",
      validation_error: "You need to fill out this field"
    },
    signature: {
      legend: "Signature",
      date: {
        label: "Date",
        placeholder: "Date for signature"
      }
    },
    supplier_rights_and_obligations: {
      compensationPercentage: {
        label: "Compensation percentage for removal of customer",
        placeholder: "Enter compensation percentage in %"
      },
      legend: "The Supplier's Rights and Obligations"
    },
    venue_governing_law: {
      legend: "Choise of Law - Venue",
      eea_or_eu: {
        label: "Does your partner have a jurisdiction outside the EU/EEA?"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/eneforhandler/translations/form/en_form.js